module.exports = "<div class=\"page-body\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <app-card [titleIcon]=\"'fas fa-exclamation-circle'\" [title]=\"'404 - Not Found'\" [classHeader]=\"true\">\n        <div class=\"text-center\" style=\"padding:20px;\">\n          <h1>Oops!</h1>\n          <h2>404 Not Found</h2>\n          <div>Sorry, an error has occured, Requested page not found!</div>\n        </div>\n      </app-card>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/errors/not-found/not-found.component.html
// module id = ./src/app/pages/errors/not-found/not-found.component.html
// module chunks = main